import React, { useContext, useEffect, useState } from "react";
import { useUnidades } from "../../../hooks/test/useUnidades";
import { Spinner } from "../../Spinner";
import { AuthContext } from "../../../context/authContext/authContext";
import { Button, Modal } from "react-bootstrap";
import { Select as Select2 } from "../../Select";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocation, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { CerrarEnRuta } from "../../../helpers/controlSidebarEnRuta";
import { SocketContext } from "../../../context/SocketContext";
import moment from "moment";
import "moment/locale/es-mx";
import { EditCreateUnidad } from "./ModalCreateEdit";

export const RegistrarEditarEventoRoboCamiones = ({ idUnidad, mostrarModal, onAction, viaje, eventAction }) => {

    const [form, setForm] = useState({
        negocio_id: "",
        negocio: "",
        id_cedis: "",
        nombre_cedis: "",
        id_monitorista: "",
        monitorista: "",
        id_unidad: "",
        unidad: "",
        placas: "",
        serie: "",
        marca: "",
        submarca: "",
        operador: "",
        numero_operador: "",
        posicion_actual: "",
        evento_seguridad_id: "",
        evento_id: "",
        estatus_evento_id: "",
        fecha_hora: "",
        coordenadas_inicio_evento: "",
        fecha_posicion_actual: "",
        municipio: "",
        estado: "",
        predenucia: "",
        carpeta_investigacion: "",
        activacion_as3: "0",
        chapas_seguridad: "0",
        observaciones: "",
        modus_operandi: "",
        vialidad: "",
        cctv: "0",
        paro_motor: "0",
        tipo_de_apoyo: [],
        predenuncia: "",
        ultimo_contacto_conductor: "",
        spot: 0,
        usuario_spot: "",
        contraseña_spot: "",
        liga_spot: "",
        fecha_registro: "",
        con_mercancia: "0",
        tripulanteId1: "",
        tripulante1: "",
        numero_tripulante1: "",
        tripulanteId2: "",
        tripulante2: "",
        numero_tripulante2: "",
        tripulanteId3: "",
        tripulante3: "",
        numero_tripulante3: "",
    });

    const {
        getEventos,
        getStatusEvento,
        getEntidadesFederativas,
        getMunicipiosId,
        postRegistroEventoSeguridad,
        postEventoSeguridad,
        getUnidad,
        putRegistroEventoSeguridad,
        postFilesUploads,
        deleteRegistroEventoSeguridad,
        getTipoApoyo,
        getPositionCamiones,
        postValidarArchivo,
        getCatalogos,
    } = useUnidades();

    const { user } = useContext(AuthContext);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [loading, setLoading] = useState(false);
    const [eventosRobo, setEventosRobo] = useState([]);
    const [statusEvento, setStatusEvento] = useState([]);
    const [startDate, setStartDate] = useState(new Date().toLocaleString("es-MX", "America/Mexico_City"));
    const [listMunicipios, setListMunicipios] = useState([]);
    const [entidadesFederativas, setEntidadesFederativas] = useState([]);
    const [tipoApoyo, setTipoApoyo] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const timers = require('timers-promises');
    const { socket } = useContext(SocketContext);
    const [actiModal, setActiModal] = useState(false);
    const modalClose = () => setActiModal(false);
    const [marcas, setMarcas] = useState([]);
    const [colores, setColores] = useState([]);

    useEffect(async () => {
        await loadData();
    }, []);

    useEffect(() => {
        handleShow();
    }, [mostrarModal]);

    const handleChange = (event) => {
        setForm({ ...form, [event.target.name]: event.target.value });
    };

    const getMunicipios = async (Id) => {
        let resp = await getMunicipiosId(Id);
        if (!resp.ok) return;
        setListMunicipios(resp.municipios);
    };

    const loadData = async () => {
        setLoading(true);

        let resCatColores = await getCatalogos(1);
        if (resCatColores.ok) {
            setColores(resCatColores.registros.camiones);
        } else {
            setColores([]);
        }

        let resCatMarcas = await getCatalogos(2);
        if (resCatMarcas.ok) {
            setMarcas(resCatMarcas.camiones.registros);
        } else {
            setMarcas([]);
        }

        let r = await getEntidadesFederativas();
        if (r.ok) setEntidadesFederativas(r.entidades);

        let res = await getEventos();
        if (res.ok) setEventosRobo(res.eventos.camiones);

        let re = await getStatusEvento();
        if (re.ok) setStatusEvento(re.estatus.camiones);

        let respue = await getTipoApoyo();
        if (respue.ok) {
            setTipoApoyo(respue.tipos_apoyo);
        }

        if (eventAction === "REGISTRAR") {
            setLoading(true);
            let resp = await getUnidad(idUnidad);
            if (resp.ok) {
                let re = await getPositionCamiones(idUnidad);
                if (re.localizacion) await getMunicipios(re.localizacion.entidad.id);
                setForm({
                    ...form,
                    negocio_id: resp.unidad.negocio.negocio_id,
                    negocio: resp.unidad.negocio.negocio_nombre,
                    cedis_id: resp.unidad.cedi.cedis_id,
                    nombre_cedis: resp.unidad.cedi.nombre_cedis,
                    id_monitorista: user.id,
                    monitorista: user.name,
                    id_unidad: resp.unidad.unidad_id,
                    unidad: resp.unidad.unidad_numero,
                    placas: resp.unidad.unidad_placas,
                    serie: resp.unidad.unidad_vin,
                    marca: resp.unidad.unidad_marca,
                    submarca: resp.unidad.unidad_modelo,
                    operador: resp.unidad.viajes[0].chofer.nombre_completo,
                    numero_operador: resp.unidad.viajes[0].chofer.telefono,
                    posicion_actual: re.posicion_actual,
                    fecha_posicion_actual: re.fecha_posicion_actual,
                    spot: resp.unidad.spot,
                    estado: re.localizacion && re.localizacion.entidad.id,
                    municipio: re.localizacion && re.localizacion.municipio.id,
                    vialidad: re.localizacion && re.localizacion.direccion,
                });

                const tripulantes = resp?.unidad?.viajes[0]?.tripulantes_viajes ?? [];

                if (tripulantes.length) {
                    setForm(prev => {
                        const nuevoForm = { ...prev };

                        tripulantes.slice(0, 3).forEach(({ tripulante }, index) => {
                            const i = index + 1;

                            nuevoForm[`tripulanteId${i}`] = tripulante?.tripulante_id || "";
                            nuevoForm[`tripulante${i}`] = tripulante?.nombre_completo || "";
                            nuevoForm[`numero_tripulante${i}`] = tripulante?.telefono || "";
                        });

                        return nuevoForm;
                    });
                }

                setLoading(false);
            } else {
                setLoading(false);
                Swal.fire({
                    title: "Error",
                    text: resp.msg ? resp.msg : "Error al cargar datos, porfavor consulte nuevamente.",
                    icon: "error",
                });
            }
                

        } else

            if (eventAction === "EDITAR") {
    

                let respu = await getUnidad(idUnidad);
                if (respu.ok) {
                    let re = await getPositionCamiones(idUnidad);
                    setForm({
                        ...form,
                        negocio_id: respu.unidad.negocio.negocio_id,
                        negocio: respu.unidad.negocio.negocio_nombre,
                        cedis_id: respu.unidad.cedi.cedis_id,
                        nombre_cedis: respu.unidad.cedi.nombre_cedis,
                        id_monitorista: user.id,
                        monitorista: respu.unidad.viajes[0].evento_seguridads[0] ? respu.unidad.viajes[0].evento_seguridads[0].usuario.name : "",
                        id_unidad: respu.unidad.unidad_id,
                        unidad: respu.unidad.unidad_numero,
                        placas: respu.unidad.unidad_placas,
                        serie: respu.unidad.unidad_vin,
                        marca: respu.unidad.unidad_marca,
                        submarca: respu.unidad.unidad_modelo,
                        operador: respu.unidad.viajes[0].chofer.nombre_completo,
                        numero_operador: respu.unidad.viajes[0].chofer.telefono,
                        evento_seguridad_id: respu.unidad.viajes[0].evento_seguridads[0] ? respu.unidad.viajes[0].evento_seguridads[0].evento_seguridad_id : "",
                        nombre_evento: respu.unidad.viajes[0].evento_seguridads[0] ? respu.unidad.viajes[0].evento_seguridads[0].evento.evento : "",
                        evento_id: respu.unidad.viajes[0].evento_seguridads[0] ? respu.unidad.viajes[0].evento_seguridads[0].evento.evento_id : "",
                        estatus_evento_id: respu.unidad.viajes[0].evento_seguridads[0] ? respu.unidad.viajes[0].evento_seguridads[0].registro_evento_seguridads[0].estatus_evento.estatus_evento_id : "",
                        nombre_estatus_evento: respu.unidad.viajes[0].evento_seguridads[0] ? respu.unidad.viajes[0].evento_seguridads[0].registro_evento_seguridads[0].estatus_evento.estatus_evento : "",
                        folio: respu.unidad.viajes[0].evento_seguridads[0] ? respu.unidad.viajes[0].evento_seguridads[0].folio : "",
                        posicion_actual: re.posicion_actual,
                        fecha_posicion_actual: re.fecha_posicion_actual,
                        carpeta_investigacion: respu.unidad.viajes[0].evento_seguridads[0] ? respu.unidad.viajes[0].evento_seguridads[0].carpeta_investigacion : "",
                        predenuncia: respu.unidad.viajes[0].evento_seguridads[0] ? respu.unidad.viajes[0].evento_seguridads[0].predenuncia : "",
                    });
                } else {
                    setLoading(false);
                    Swal.fire({
                        title: "Error",
                        text: respu.msg ? respu.msg : "Error al cargar datos, porfavor consulte nuevamente.",
                        icon: "error",
                    });
                }
            }
        setLoading(false);
    }

    const registrarEventoRobo = async () => {
        let err = false;

        // validar datos de la unidad para envio completo de informacion
        if (form.placas === "" || form.serie === "" || form.marca === "") {
            toast.error("¡Unidad con datos incompletos! favor de actualizarla", { position: toast.POSITION.BOTTOM_CENTER, });
            err = true;
        }
        // ./
        if (form.evento_id === "") {
            toast.error("Por favor selecciona un evento!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (form.vialidad === "") {
            toast.error("Por favor agrega la vialidad del evento!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (form.posicion_actual === "") {
            toast.error("Por favor agrega las coordenadas de inicio de evento!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (form.municipio === "") {
            toast.error("Por favor agrega el municipio!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (form.estado === "") {
            toast.error("Por favor agrega el estado!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (form.ultimo_contacto_conductor === "") {
            toast.error("¡Por favor selecciona fecha y hora de registro del último contacto con la tripulación!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (form.spot && (form.usuario_spot === "" || form.contraseña_spot === "" || form.liga_spot === "")) {
            toast.error("¡Datos de unidad spot incompletos, favor de rellenar los 3 campos necesarios!", {
                position: toast.POSITION.BOTTOM_CENTER,
            });
            err = true;
        }

        if (err === false) {
            setLoading(true);

            let usuario_spot;
            let contrasenia_spot;
            let liga_spot;
            if (form.spot) {
                usuario_spot = form.usuario_spot;
                contrasenia_spot = form.contraseña_spot;
                liga_spot = form.liga_spot;
            }

            let res = await postRegistroEventoSeguridad({
                "viaje_id": viaje.viaje_id,
                "evento_id": form.evento_id,
                "municipio_id": form.municipio,
                "estado_id": form.estado,
                "coordenadas_inicio": form.coordenadas_inicio_evento,
                "activacion_as3": form.activacion_as3 ? "SI" : "NO",
                "modus_operandi": form.modus_operandi,
                "chapa_seguridad": form.chapas_seguridad ? "SI" : "NO",
                "vialidad": form.vialidad,
                "cctv": form.cctv ? 1 : 0,
                "mercancia": form.con_mercancia ? true : false,
                "paro_motor": form.paro_motor ? 1 : 0,
                "ultimo_contacto_conductor": form.ultimo_contacto_conductor,
                usuario_spot,
                contrasenia_spot,
                liga_spot,
            });

            if (res.ok) {
                let resp = await postEventoSeguridad({
                    "evento_seguridad_id": res.evento_seguridad.evento_seguridad_id,
                    "estatus_evento_id": 2,
                    "fecha_hora": form.fecha_registro,
                    "coordenadas_online": form.posicion_actual,
                    "fecha_coordenadas_online": form.fecha_posicion_actual,
                    "observaciones": form.observaciones,
                });
                if (resp.ok) {
                    setLoading(false);
                    CerrarEnRuta();
                    Swal.fire({
                        title: "REGISTRO DE EVENTO DE ROBO",
                        text: "Guardado correctamente",
                        showConfirmButton: false,
                        icon: "success",
                        timer: 3000
                    });
                    
                    socket.emit("new_event_robo", { idNegocio: parseInt(viaje.unidad.negocio.negocio_id) });
                    console.log("new evet: ", parseInt(viaje.unidad.negocio.negocio_id));

                    handleClose();
                    resetForm();
                } else {
                    setLoading(false);
                    Swal.fire({
                        title: "Error",
                        text: resp.msg,
                        icon: "error",
                    });
                }
            } else {
                setLoading(false);
                console.log("error en registro-seguridad");
                Swal.fire({
                    title: "Error",
                    text: res.msg,
                    icon: "error",
                });
            }
        }
    }

    const resetForm = () => {
        setForm({
            negocio_id: "",
            negocio: "",
            id_cedis: "",
            nombre_cedis: "",
            id_monitorista: "",
            monitorista: "",
            id_unidad: "",
            unidad: "",
            placas: "",
            serie: "",
            marca: "",
            submarca: "",
            operador: "",
            numero_operador: "",
            posicion_actual: "",
            evento_seguridad_id: "",
            evento_id: "",
            estatus_evento_id: "",
            fecha_hora: "",
            coordenadas_inicio_evento: "",
            fecha_posicion_actual: "",
            municipio: "",
            estado: "",
            predenucia: "",
            carpeta_investigacion: "",
            activacion_as3: "",
            chapas_seguridad: "",
            observaciones: "",
            modus_operandi: "",
            vialidad: "",
            cctv: "",
            paro_motor: "0",
            tipo_de_apoyo: [],
            predenuncia: "",
            ultimo_contacto_conductor: "",
            spot: 0,
            fecha_registro: "",
        });
        setListMunicipios([]);
    };

    const actualizarEventoRobo = async () => {
        setLoading(true);
        let resp = false;
        let formData = new FormData();
        formData.append('archivo', selectedFile);
        if (selectedFile !== null) {
            const validar = await postValidarArchivo(formData);
            if (!validar.ok) {
                setLoading(false);
                return Swal.fire({
                    title: "¡Lo siento!",
                    text: validar.msg,
                    icon: "info",
                }); 
            }
        }
        resp = await postEventoSeguridad({
            "evento_seguridad_id": form.evento_seguridad_id,
            "estatus_evento_id": form.estatus_evento_id,
            "apoyo_tipo_id": form.tipo_de_apoyo,
            "fecha_hora": startDate,
            "coordenadas": form.coordenadas_fin_evento,
            "coordenadas_online": form.posicion_actual,
            "fecha_posicion_actual": form.fecha_posicion_actual,
            "lugar": form.lugar_remitido,
            "observaciones": form.observaciones,
        });

        if (resp.ok) {
            let re = putRegistroEventoSeguridad({
                "carpeta_investigacion": form.carpeta_investigacion,
                "predenuncia": form.predenuncia,
            }, form.evento_seguridad_id);
            console.log(re);

            if (selectedFile === null) {
                resp = {
                    "ok": true,
                    "msg": "Sin archivos cargados"
                }
            } else {
                resp = await postFilesUploads(formData, resp.registro.registro_evento_id);
                if (!resp.ok) console.log("error al cargar el archivo: " + resp);
            }

            if (resp.ok && (form.estatus_evento_id !== 2 && form.estatus_evento_id !== "2")) {
                let res = await deleteRegistroEventoSeguridad(form.evento_seguridad_id);
                if (res.ok) {
                    setLoading(false);

                    Swal.fire({
                        title: "REGISTRO DE EVENTO DE ROBO",
                        text: "Finalizado correctamente",
                        showConfirmButton: false,
                        icon: "success",
                        timer: 3000
                    });
                    socket.emit("update_event_security");
                    handleClose();
                    resetForm();
                    setSelectedFile(null);
                    await timers.setTimeout(3000, 'result').then((res) => {
                        loadData();
                    });

                } else {
                    setLoading(false);
                    Swal.fire({
                        title: "Error",
                        text: resp.msg,
                        icon: "error",
                    });
                }

            } else if (resp.ok && (form.estatus_evento_id === 2 || form.estatus_evento_id === "2")) {
                setLoading(false);
                Swal.fire({
                    title: "REGISTRO DE EVENTO DE ROBO",
                    text: "Actualizado correctamente",
                    showConfirmButton: false,
                    icon: "success",
                    timer: 3000
                });
                handleClose();
                resetForm();
                setSelectedFile(null);

            } else if (!resp.ok) {
                setLoading(false);
                Swal.fire({
                    title: "Error",
                    text: resp.msg,
                    icon: "error",
                });
            }
        } else {
            setLoading(false);
            Swal.fire({
                title: "Error",
                text: resp.msg,
                icon: "error",
            });
        }
    }

    const handleFileUpload = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const actUnidad = async () => {
        setLoading(true);
        let r = await getUnidad(form.id_unidad);
        if (r.ok) {
            let re = await getPositionCamiones(form.id_unidad);
            if (re.localizacion) await getMunicipios(re.localizacion.entidad.id);
            setForm(prev => ({
                ...prev,
                unidad: r.unidad.unidad_numero,
                placas: r.unidad.unidad_placas,
                serie: r.unidad.unidad_vin,
                marca: r.unidad.unidad_marca,
                submarca: r.unidad.unidad_modelo,
                spot: r.unidad.spot,

                posicion_actual: re.posicion_actual,
                fecha_posicion_actual: re.fecha_posicion_actual,
                estado: re.localizacion && re.localizacion.entidad.id,
                municipio: re.localizacion && re.localizacion.municipio.id,
                vialidad: re.localizacion && re.localizacion.direccion,
            }));
            setLoading(false);
        } else {
            setLoading(false);
            Swal.fire({
                title: "Error",
                text: "Error al actualizar registros",
                icon: "error",
            });
        }
    }

    return (
        <>
            {loading && <Spinner />}
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                fullscreen={true}
                keyboard={false}
            >
                <Modal.Header>
                    {
                        eventAction === "REGISTRAR" ? (<><h3> REGISTRO DE EVENTO </h3></>) :
                            eventAction === "EDITAR" ? (<><h3> ACTUALIZACIÓN DE EVENTO</h3></>) : ""
                    }

                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-5 card">
                            <div className="row">
                                <div className="col form-group">
                                    <label>Negocio</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.negocio}
                                        disabled
                                    />
                                </div>
                                <div className="col form-group">
                                    <label>Cedis</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.nombre_cedis}
                                        disabled
                                    />
                                </div>
                                <div className="col form-group">
                                    <label>Monitorista</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.monitorista}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-7 card ml-1">
                            <div className="row">
                                 <div
                                    style={{
                                        width: "50px"
                                    }}
                                >
                                    <a
                                        style={{
                                            fontSize: "25px",
                                            position: "relative",
                                            top: "30px",
                                            color: "#4869fc",
                                            cursor: "pointer"
                                        }}
                                        onClick={() =>
                                        // lert("clic")
                                        (
                                            setActiModal(true)
                                        )
                                        }
                                        title="Editar unidad"
                                    >
                                        <FontAwesomeIcon icon={faPenToSquare} />
                                    </a>
                                </div>
                                <div className="col form-group">
                                    <label>Unidad</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.unidad}
                                        disabled
                                    />
                                </div>
                                <div className="col form-group">
                                    <label>Placas</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.placas == null ? '' : form.placas}
                                        disabled
                                    />
                                </div>
                                <div className="col form-group">
                                    <label>Serie</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.serie == null ? '' : form.serie}
                                        disabled
                                    />
                                </div>
                                <div className="col form-group">
                                    <label>Marca</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.marca == null ? '' : form.marca}
                                        disabled
                                    />
                                </div>
                                <div className="col form-group">
                                    <label>Submarca</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.submarca == null ? '' : form.submarca}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-3 card">
                            <div className="row">
                                {
                                    eventAction === "EDITAR" ? (
                                        <>
                                            <div className="col-12 form-group">
                                                <label>Asunto</label>
                                                <Select2
                                                    name="evento_id"
                                                    value={form.evento_id}
                                                    options={eventosRobo.map((x) => {
                                                        return { value: x.evento_id, text: x.evento };
                                                    })}
                                                    onChange={(event) => { handleChange(event) }}
                                                    className="form-control mt-2"
                                                    placeholder="Selecciona evento"
                                                />
                                            </div>
                                            <div className="col-12 form-group">
                                                <label>Estatus Evento</label>

                                                <Select2
                                                    name="estatus_evento_id"
                                                    value={form.estatus_evento_id}
                                                    options={statusEvento.map((x) => {
                                                        return { value: x.estatus_evento_id, text: x.estatus_evento };
                                                    })}
                                                    className="form-control mt-2"
                                                    onChange={(event) => { handleChange(event) }}
                                                    placeholder="Selecciona estatus evento"
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="col form-group">
                                                <label>Asunto</label>
                                                <Select2
                                                    name="evento_id"
                                                    value={form.evento_id}
                                                    options={eventosRobo.map((x) => {
                                                        return { value: x.evento_id, text: x.evento };
                                                    })}
                                                    onChange={(event) => { handleChange(event) }}
                                                    className="form-control mt-2"
                                                    placeholder="Selecciona evento"
                                                />
                                            </div>
                                        </>
                                    )
                                }
                            </div>
                        </div>
                        <div className="col-9 card ml-1">
                            <div className="row">
                                <div className="col form-group">
                                    <label>Operador</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.operador}
                                        disabled
                                    />
                                </div>
                                <div className="col form-group">
                                    <label>Número telefonico</label>
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        value={form.numero_operador}
                                        disabled
                                    />
                                </div>
                                {
                                    form.tripulante1 && (
                                        <>
                                            <div className="col form-group">
                                                <label>Tripulante</label>
                                                <input
                                                    type="text"
                                                    className="form-control mb-3"
                                                    value={form.tripulante1}
                                                    disabled
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control mb-3"
                                                    value={form.numero_tripulante1}
                                                    disabled
                                                />
                                            </div>
                                        </>
                                    )
                                }
                                {
                                    form.tripulante2 && (
                                        <>
                                            <div className="col form-group">
                                                <label>Tripulante</label>
                                                <input
                                                    type="text"
                                                    className="form-control mb-3"
                                                    value={form.tripulante2}
                                                    disabled
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control mb-3"
                                                    value={form.numero_tripulante2}
                                                    disabled
                                                />
                                            </div>
                                        </>
                                    )
                                }
                                {
                                    form.tripulante3 && (
                                        <>
                                            <div className="col form-group">
                                                <label>Operador</label>
                                                <input
                                                    type="text"
                                                    className="form-control mb-3"
                                                    value={form.tripulante3}
                                                    disabled
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control mb-3"
                                                    value={form.numero_tripulante3}
                                                    disabled
                                                />
                                            </div>
                                        </>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    {
                        eventAction === "REGISTRAR" ? (
                            <>
                                <div className="row mt-4">
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Fecha y hora</label>
                                            <input
                                                // type="text"
                                                // className="form-control"
                                                // value={
                                                //     startDate
                                                // }
                                                type="datetime-local"
                                                name="fecha_registro"
                                                className="form-control mt-2"
                                                value={form.fecha_registro}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Vialidad</label>
                                            <input
                                                type="text"
                                                name="vialidad"
                                                className="form-control mb-3"
                                                value={form.vialidad}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Coordenadas inicio evento</label>
                                            <input
                                                type="text"
                                                name="coordenadas_inicio_evento"
                                                className="form-control mb-3"
                                                value={form.coordenadas_inicio_evento}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2 mb-3">

                                        <label>Coordenadas registro</label>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <a
                                                    style={{
                                                        padding: "15px 20px",
                                                        position: "relative",
                                                        background: "#ffcd00",
                                                        top: "23px",
                                                        cursor: "pointer"
                                                    }}
                                                    data-toggle="tooltip"
                                                    title={
                                                        form.fecha_posicion_actual && form.fecha_posicion_actual != "" ? (
                                                            moment(form.fecha_posicion_actual).format("YYYY-MM-DD HH:mm:ss")
                                                        ) : ""
                                                    }
                                                    onClick={() => {
                                                        let array = form.posicion_actual.split(",");
                                                        window.open(
                                                            `https://www.google.es/maps?q=${array[0]},${array[1]}`
                                                        )
                                                    }}

                                                >
                                                    <FontAwesomeIcon icon={faMapLocation} />
                                                </a>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="posicion_actual"
                                                value={
                                                    form.fecha_posicion_actual && form.fecha_posicion_actual != "" ? (
                                                        form.posicion_actual
                                                    ) : ""
                                                }
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Estado</label>
                                            {
                                                eventAction === "REGISTRAR" ? (
                                                    <>
                                                        <select
                                                            className="form-control mt-2"
                                                            onChange={(event) => {
                                                                setForm({ ...form, estado: event.target.value });
                                                                getMunicipios(event.target.value);
                                                            }}
                                                            value={form.estado}
                                                            defaultValue
                                                        >
                                                            <option value="" selected={true} disabled>
                                                                ---
                                                            </option>
                                                            {entidadesFederativas.map((x) => {
                                                                return (
                                                                    <option value={x.entidad_federativa_id} key={x.entidad_federativa_id}>
                                                                        {x.entidad_federativa}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                    </>
                                                ) : ""
                                            }
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>Alcaldía/Municipio</label>
                                            {
                                                eventAction === "REGISTRAR" ? (
                                                    <>
                                                        <Select2
                                                            options={listMunicipios.map((x) => {
                                                                return { value: x.municipio_id, text: x.municipio };
                                                            })}
                                                            className="form-control mt-2"
                                                            onChange={(event) =>
                                                                setForm({ ...form, municipio: event.target.value })
                                                            }
                                                            value={form.municipio}
                                                            defaultValue
                                                            placeholder="Selecciona tu municipio"
                                                            required
                                                        />
                                                    </>
                                                ) : ""

                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-2">
                                        <div className="form-group">
                                            <div className="form-check" style={{ margin: "35px" }}>
                                                <input
                                                    name="activacion_as3"
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    onChange={(event) => {
                                                        setForm({ ...form, activacion_as3: event.target.checked })
                                                    }}
                                                    checked={form.activacion_as3 ? true : false}
                                                />
                                                <label className="form-check-label">
                                                    AS3
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <div className="form-check" style={{ margin: "35px" }}>
                                                <input
                                                    name="chapas_seguridad"
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    onChange={(event) => {
                                                        setForm({ ...form, chapas_seguridad: event.target.checked })
                                                    }}
                                                    checked={form.chapas_seguridad ? true : false}
                                                />
                                                <label className="form-check-label">
                                                    Chapa seguridad
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-check" style={{ margin: "35px" }}>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={(event) => {
                                                    setForm({ ...form, paro_motor: event.target.checked })
                                                }}
                                                checked={form.paro_motor ? true : false}
                                            />
                                            <label className="form-check-label">
                                                Paro de motor
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-check" style={{ margin: "35px" }}>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={(event) => {
                                                    setForm({ ...form, cctv: event.target.checked })
                                                }}
                                                checked={form.cctv ? true : false}
                                            />
                                            <label className="form-check-label">
                                                CCTV
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-check" style={{ margin: "35px" }}>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={(event) => {
                                                    setForm({ ...form, con_mercancia: event.target.checked })
                                                }}
                                                checked={form.con_mercancia ? true : false}
                                            />
                                            <label className="form-check-label">
                                                Con mercancía
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="form-group">
                                            <label>último contacto con la tripulación </label>
                                            <input
                                                type="datetime-local"
                                                name="ultimo_contacto_conductor"
                                                className="form-control mt-2"
                                                value={form.ultimo_contacto_conductor}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    {
                                        form.spot ? (
                                            <>
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label>Usuario spot</label>
                                                        <input
                                                            type="text"
                                                            name="usuario_spot"
                                                            className="form-control mb-3"
                                                            value={form.usuario_spot}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label>Contraseña spot</label>
                                                        <input
                                                            type="text"
                                                            name="contraseña_spot"
                                                            className="form-control mb-3"
                                                            value={form.contraseña_spot}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label>Liga spot</label>
                                                        <input
                                                            type="text"
                                                            name="liga_spot"
                                                            className="form-control mb-3"
                                                            value={form.liga_spot}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        ) : ""
                                    }
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>Nota</label>
                                            <textarea
                                                className="form-control mb-3"
                                                rows="3"
                                                name="observaciones"
                                                value={form.observaciones}
                                                onChange={handleChange}
                                                spellCheck={true} lang="es"
                                                autoCorrect="on"
                                                autoCapitalize="on"
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>Modus operandi</label>
                                            <textarea
                                                className="form-control mb-3"
                                                rows="3"
                                                name="modus_operandi"
                                                value={form.modus_operandi}
                                                onChange={handleChange}
                                                spellCheck={true} lang="es"
                                                autoCorrect="on"
                                                autoCapitalize="on"
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) :
                            eventAction === "EDITAR" ? (
                                <>
                                    <div className="row mt-4">
                                        <div className="col-2">
                                            <div className="form-group">
                                                <label>Fecha y hora</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={
                                                        startDate
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Fecha-hora coordenadas de registro</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="fecha_posicion_actual"
                                                    value={form.fecha_posicion_actual}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <div className="form-group">
                                                <label>Coordenadas de registro</label>
                                                <input
                                                    type="text"
                                                    name="posicion_actual"
                                                    className="form-control mb-3"
                                                    value={form.posicion_actual}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <div className="form-group">
                                                <label>Coordenadas de seguimiento</label>
                                                <input
                                                    type="text"
                                                    name="coordenadas_fin_evento"
                                                    className="form-control mb-3"
                                                    value={form.coordenadas_fin_evento}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="col form-group">
                                                <label>Corporaciones </label>
                                                <Select
                                                    name="tipo_de_apoyo"
                                                    options={tipoApoyo.map((x) => {
                                                        return { value: x.apoyo_tipo_id, label: x.apoyo_tipo };
                                                    })}
                                                    isMulti
                                                    className="form-control mt-2"
                                                    classNamePrefix={"select"}
                                                    value={form.tipo_de_apoyo}
                                                    onChange={(event) => {

                                                        let aux = [];
                                                        event.forEach((label) => {
                                                            aux.push(label);
                                                        });

                                                        setForm({ ...form, tipo_de_apoyo: aux })
                                                    }}
                                                    placeholder="Selecciona el tipo de apoyo"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-5">
                                            <div className="form-group">
                                                <label>Lugar donde será remitida</label>
                                                <input
                                                    type="text"
                                                    name="lugar_remitido"
                                                    className="form-control mb-3"
                                                    value={form.lugar_remitido}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <div className="form-group">
                                                <label>Cargar archivo</label>

                                                <input
                                                    style={{ marginTop: "8px" }}
                                                    name="cargar_archivo"
                                                    className="form-control mb-3"
                                                    type="file"
                                                    accept=".xlsx,.xls, .csv/*,.doc, .docx, .pdf, image/*, video/mp4"
                                                    onChange={handleFileUpload}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <div className="form-group">
                                                <label>Carpeta de investigación:</label>
                                                <input
                                                    type="text"
                                                    name="carpeta_investigacion"
                                                    className="form-control mb-3"
                                                    value={form.carpeta_investigacion}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label>Predenuncia:</label>
                                                <input
                                                    type="text"
                                                    name="predenuncia"
                                                    className="form-control mb-3"
                                                    value={form.predenuncia}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label>Nota</label>
                                                <textarea
                                                    className="form-control mb-3"
                                                    rows="3"
                                                    name="observaciones"
                                                    value={form.observaciones}
                                                    onChange={handleChange}
                                                >
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : ""
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        onClick={() => (
                            eventAction === "REGISTRAR" ? registrarEventoRobo() : eventAction === "EDITAR" ? actualizarEventoRobo() : ""
                        )}
                    >
                        {
                            eventAction === "REGISTRAR" ? "REGISTRAR" : eventAction === "EDITAR" ? "ACTUALIZAR" : ""
                        }
                    </Button>
                    <Button variant="secondary" onClick={() => (handleClose(), resetForm(), onAction())}>
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
             {
                actiModal &&
                <EditCreateUnidad
                    negocio_id={form.negocio_id}
                    unidad_id={form.id_unidad}
                    marcas={marcas}
                    colores={colores}
                    show={actiModal}
                    handleClose={modalClose}
                    refreshUnidades={() => { actUnidad(); }}
                />
            }
        </>
    );
}